<template>
  <NavBars />
  <CharTabGötterlicht />
</template>

<script>
import { defineComponent } from 'vue';

// Components
import NavBars from '@/components/NavBars.vue';
import CharTabGötterlicht from '@/components/CharTabGötterlicht.vue';

export default defineComponent({
  components: {
    NavBars, CharTabGötterlicht
    },
});
</script>